// extracted by mini-css-extract-plugin
export default {"list":"List_list__93HgO","end":"List_end__wyv--","btn":"List_btn__Krv3t","wrapper":"List_wrapper__GbFMy","loader":"List_loader__QaogJ","searchText":"List_searchText__z6F-G"};